const init = ({ initialPosts, initialPage, initialTotal, postType, postsPerPage, activeTaxonomies }) => {
  return {
    posts: initialPosts,
    page: initialPage,
    totalPages: initialTotal,
    postType: postType,
    postsPerPage: postsPerPage || 10,
    activeTaxonomies: activeTaxonomies || [], 
    
    activeFilters: {}, 
    searchQuery: '',
    
    loading: false,
    urlPrefix: '_', 

    get visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 1; 
      const range = [];
      const rangeWithDots = [];
      let l;

      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
          range.push(i);
        }
      }

      range.forEach(i => {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      });

      return rangeWithDots;
    },

    init() {
        const params = new URLSearchParams(window.location.search);
        
        // Hydrate Filters
        if (this.activeTaxonomies.length) {
            this.activeTaxonomies.forEach(tax => {
                const termId = params.get(this.urlPrefix + tax);
                if (termId) {
                    this.activeFilters[tax] = termId;
                }
            });
        }

        // Hydrate Search
        const search = params.get(this.urlPrefix + 'search');
        if (search) {
            this.searchQuery = search;
        }

        // Watcher for Search
        // Triggers loadPage whenever searchQuery updates (after the x-model debounce)
        this.$watch('searchQuery', (value) => {
            this.loadPage(1);
        });

        // Hydrate Pagination & Initial Fetch Decision
        const pg = parseInt(params.get('pg'));
        const hasFilters = Object.keys(this.activeFilters).length > 0;
        
        // We only force a fetch if we have state that PHP likely didn't handle
        if (hasFilters || this.searchQuery || (pg && pg !== 1)) {
            this.loadPage(pg || 1, false);
        }

        // Back/Forward Listener
        window.addEventListener('popstate', () => {
            window.location.reload(); 
        });
    },

    async loadPage(n = 1, updateURL = true) {
      if (n < 1) return;

      const container = document.getElementById('posts-container');
      if (container) {
          const containerTop = container.getBoundingClientRect().top + window.scrollY;
          const currentScroll = window.scrollY;
          const offset = 100; 
          
          if (currentScroll > (containerTop - offset + 50)) {
              window.scrollTo({
                  top: containerTop - offset, 
                  behavior: 'smooth'
              });
          }
      }

      this.loading = true;

      const perPage = this.postsPerPage;
      let endpoint = this.postType || 'posts';
      if (endpoint === 'post') endpoint = 'posts';
      
      let url = `/wp-json/wp/v2/${endpoint}?per_page=${perPage}&page=${n}`;

      if (this.searchQuery) {
          url += `&search=${encodeURIComponent(this.searchQuery)}`;
      }

      Object.keys(this.activeFilters).forEach(tax => {
          const termId = this.activeFilters[tax];
          if (termId) {
              let apiParam = tax;
              if (apiParam === 'category') apiParam = 'categories';
              if (apiParam === 'post_tag') apiParam = 'tags';
              
              url += `&${apiParam}=${termId}`;
          }
      });
      
      // console.log(`Fetching posts from: ${url}`);
      
      try {
          const res = await fetch(url);
          const total = res.headers.get("X-WP-TotalPages");
          if (total) this.totalPages = parseInt(total, 10);

          if (!res.ok) throw new Error(`API Error: ${res.status}`);

          this.page = n;
          const data = await res.json();
          
          this.posts = data.map((p) => ({
            id: p.id,
            title: p.title?.rendered || "",
            excerpt: String(p.excerpt?.rendered || p.excerpt || "").replace(/<\/?[^>]+(>|$)/g, ""), 
            link: p.link || "#",
            type: p.type || "",
            thumbnail: {
              src: p.featured_image?.url || "",
              alt: p.featured_image?.alt || "",
            },
          }));

          if (updateURL) {
              const query = new URLSearchParams(window.location.search);
              
              this.activeTaxonomies.forEach(tax => query.delete(this.urlPrefix + tax));
              query.delete(this.urlPrefix + 'search');

              Object.keys(this.activeFilters).forEach(tax => {
                  if (this.activeFilters[tax]) {
                      query.set(this.urlPrefix + tax, this.activeFilters[tax]);
                  }
              });

              if (this.searchQuery) {
                  query.set(this.urlPrefix + 'search', this.searchQuery);
              }

              query.set("pg", this.page);
              history.pushState(null, "", `?${query.toString()}`);
          }

      } catch (error) {
          // console.error("Error loading posts:", error);
      }

      this.loading = false;
    },

    filterBy(taxonomy, termId) {
      if (this.activeFilters[taxonomy] == termId) {
        delete this.activeFilters[taxonomy];
      } else {
        this.activeFilters[taxonomy] = termId;
      }
      this.loadPage(1); 
    },

  // Function to clear all filters and search
    resetFilters() {
        // Clear the filters (this doesn't trigger any watchers)
        this.activeFilters = {};

        // Check if we need to clear the search
        if (this.searchQuery) {
            // Case A: There is text in the search bar.
            // Action: Clearing it triggers the $watch('searchQuery') automatically.
            // Result: The watcher calls loadPage(1) for us. We do NOT call it here.
            this.searchQuery = '';
        } else {
            // Case B: Search bar is already empty.
            // Action: The watcher won't fire because the value didn't change.
            // Result: We MUST call loadPage(1) manually to reset the taxonomy filters.
            this.loadPage(1);
        }
    },

    isActive(taxonomy, termId) {
        return this.activeFilters[taxonomy] == termId;
    }
  };
};

export default init;